// Canonical Circle-of-Support group definitions — the PRINT / PDF side.
//
// MIRROR of app/helpers/circle_of_support_groups.rb (the editor side). Keep the
// keys, order, and filters in sync. "Who Lives With Me" is NOT here — it's a
// separate array (about.whoLivesWithMe) rendered as its own tile by the print
// controller before these. Service Dog / TBD are not printed (no group).
export const COS_GROUPS = [
  { key: "family_outside", filter: "Family",       excludeLinked: true,
    pdfColor: "red",     pdfIcon: "heart",     pdfTitle: "Family (not in home)", pbKey: "cos_family" },
  { key: "friend",         filter: "Friend",       excludeLinked: false,
    pdfColor: "amber",   pdfIcon: "users",     pdfTitle: "Friends",              pbKey: "cos_friend" },
  { key: "professional",   filter: "Professional", excludeLinked: false,
    pdfColor: "sky",     pdfIcon: "briefcase", pdfTitle: "Professionals",        pbKey: "cos_professional" },
  { key: "community",      filter: "Community",    excludeLinked: false,
    pdfColor: "emerald", pdfIcon: "map-pin",   pdfTitle: "Community",            pbKey: "cos_community" }
]
